import React from 'react'
import { Outlet } from 'react-router-dom'
import { MdMapsHomeWork } from "react-icons/md";

const LayoutActvityAdmin = () => {
  return (
    <div>
      <div className=" w-full px-3 py-2">
        <div className="  w-full relative w-full flex flex-col space-x-2">
          <div className=" py-1 my-2 mx-1 bg-emerald-800 text-white px-2 py-2 rounded-lg flex justify-center ">
            <h2 className="  text-white flex space-x-3 items-center text-xl">
              <MdMapsHomeWork className="translatable text-white w-8 h-8" /><span className="translatable">Activtés</span>
            </h2>
          </div>
          <div className=" w-full px-2 shadow-md">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LayoutActvityAdmin;
